import { useQuery } from '@tanstack/react-query';
import { CatchmentFormValues } from '@/components/catchmentform/CatchmentForm';

async function fetchCatchmentArea(area: CatchmentFormValues | null): Promise<any> {
  if (!area) {
    return null;
  }

  const baseUrl = `https://${process.env.NEXT_PUBLIC_API_ID}.execute-api.${process.env.NEXT_PUBLIC_REGION}.amazonaws.com/dev/catchment`;

  const params = new URLSearchParams({
    ...(area.basin && { basin: area.basin }),
    ...(area.managementCatchment && { managementCatchment: area.managementCatchment }),
    ...(area.operationalCatchment && { operationalCatchment: area.operationalCatchment }),
  }).toString();

  const url = `${baseUrl}?${params}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Error fetching catchment data: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch catchment data:', error);
    throw error;
  }
}

export const useCatchmentQuery = (catchment: CatchmentFormValues | null) => {
  return useQuery({
    queryKey: [
      'catchment',
      catchment?.basin,
      catchment?.managementCatchment,
      catchment?.operationalCatchment,
    ],
    queryFn: () => fetchCatchmentArea(catchment),
    enabled: !!catchment,
  });
};
